export const signMessage = async signer => {
  const timestamp = `${new Date().getTime()}`
  const msg = await signer?.signMessage(
    `Hello there! ✌️\n\nTo securely log in to our app, we kindly ask you to sign this message using your Metamask wallet. This process is similar to a social login and is solely intended to verify your wallet ownership.\n\n This signature does not involve any fees or transfer of funds.\n\nTimestamp: ${timestamp}`
  )
  return { msg, timestamp }
}
